import "@typeform/embed/build/css/popup.css";
import {
  WSElement,
  WSPage,
  WSPageToolbar,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import { RouteComponentProps } from "react-router";
import { useBrowserPageTitle } from "../../../shared/hooks/useBrowserPageTitle";
import { axisBenefits } from "../components/customBenefits/axisBenefits";
import { PATH_BENEFITS_AXIS_INSURANCE } from "../paths";
import styles from "./Benefits.module.scss";
import { BenefitsCMSBlock } from "./BenefitsCMSBlock";

export const RouteAxisInsurance: React.FC<RouteComponentProps> = () => {
  useBrowserPageTitle("Benefits - Insurance");

  return (
    <WSPage>
      <WSPageToolbar title="Insurance">
        <WSText.ParagraphSm color="gray600" className={styles.text}>
          Accessing high quality insurance for independent contractors is
          difficult. Wingspan has partnered with providers who have designed
          plans specifically for independent professionals.
        </WSText.ParagraphSm>
      </WSPageToolbar>

      <WSElement>
        {axisBenefits.map(benefit => (
          <BenefitsCMSBlock
            key={benefit.slug}
            benefit={benefit}
            pagePath={PATH_BENEFITS_AXIS_INSURANCE + "/" + benefit.slug}
          />
        ))}
      </WSElement>
    </WSPage>
  );
};
